export default __webpack_public_path__ + "static/maskbg-08c6bb1cc904860794d7c4d40454e7da.png";